<template>
	<div class="app-container">
		<el-card class="filter-card" shadow="hover">
			<el-form :inline="true" :model="name" class="filter-form">
				<el-form-item>
					<el-button type="primary" @click="handleAddQuotation">
						<el-icon>
							<Plus />
						</el-icon> 新增报价
					</el-button>
				</el-form-item>
				<el-form-item>
					<el-divider direction="vertical"></el-divider>
				</el-form-item>
				<el-form-item label="报价编号">
					<el-input v-model="filterForm.name" style="width: 180px" placeholder="请输入报价编号" clearable />
				</el-form-item>
				<!-- <el-form-item label="客户名称">
                    <el-input v-model="filterForm.customerName" placeholder="请输入客户名称"></el-input>
                </el-form-item> -->
				<el-form-item label="客户名称">
					<!-- <el-input v-model="filterForm.customerName" placeholder="请输入客户名称" clearable @keyup.enter="handleSearch" /> -->
					<el-select v-model="filterForm.customerId" placeholder="选择客户" filterable remote
						:remote-method="handleCustomerSearch" :loading="customerSearchLoading" clearable>
						<el-option v-for="item in customerOptions" :key="item.id" :label="item.customerName"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="报价状态">
					<el-select v-model="filterForm.status" placeholder="选择报价状态" clearable style="width: 130px;">
						<!-- <el-option label="草稿" value="draft"></el-option> -->
						<el-option label="未审核" :value="9"></el-option>
						<el-option label="审核中" :value="0"></el-option>
						<el-option label="已审核" :value="1"></el-option>
						<el-option label="已拒绝" :value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="报价归属">
					<el-select v-model="filterForm.type" placeholder="选择状态" style="width: 130px;">
						<el-option label="全部" value="all" />
						<el-option label="我的" value="my" />
						<el-option label="下属的" value="subordinate" />
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="时间范围">
                    <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" value-format="YYYY-MM-DD">
                    </el-date-picker>
                </el-form-item> -->
				<el-form-item>
					<el-button type="primary" @click="handleSearch">查询</el-button>
					<el-button @click="resetForm">重置</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<el-card class="table-card" shadow="hover">
			<el-table :data="quotationList" style="width: 100%" height="calc(100vh - 320px)" v-loading="loading" stripe>
				<el-table-column type="index" label="序号" width="60" />
				<el-table-column prop="name" label="报价编号" width="150"></el-table-column>
				<el-table-column prop="customerName" label="客户名称" min-width="240"></el-table-column>
				<el-table-column prop="offerPrice" label="报价金额" width="160">
					<template #default="scope">
						{{ formatAmount(scope.row.offerPrice) }}
					</template>
				</el-table-column>
				<el-table-column prop="offerTime" label="报价时间" width="130">
					<template #default="scope">
						{{ formatDate(scope.row.offerTime) }}
					</template>
				</el-table-column>
				<el-table-column prop="status" label="报价状态" width="120">
					<template #default="scope">
						<el-tag :type="getStatusType(scope.row.status)">
							{{ getStatusText(scope.row.status) }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="180">
					<template #default="scope">
						{{ formatDateTime(scope.row.createTime) }}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="240" fixed="right">
					<template #default="scope">
						<el-button size="small" type="warning" @click="handleView(scope.row)">详情</el-button>
						<el-button v-if="scope.row.status === 9 || scope.row.status === 4" size="small" type="primary"
							@click="handleEdit(scope.row)">编辑</el-button>
						<el-button v-if="scope.row.status === 9 || scope.row.status === 4" size="small" type="success"
							@click="handleSubmit(scope.row)">提交审批</el-button>
						<el-button v-if="scope.row.status === 0" size="small" type="danger"
							@click="handleSubmit(scope.row)">撤回审批</el-button>
						<!-- <el-button v-if="scope.row.status === 'approved'" size="mini" type="primary"
                            @click="handleSend(scope.row)">发送给客户</el-button>
                        <el-button v-if="scope.row.status === 'draft'" size="mini" type="danger"
                            @click="handleDelete(scope.row)">删除</el-button> -->
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination-container">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</el-card>

		<!-- 查看报价详情对话框 -->
		<el-dialog class="mydialog" title="报价详情" v-model="viewDialogVisible" width="50vw" :close-on-click-modal="false"
			align-center>
			<el-tabs v-model="activeTab" type="border-card">
				<el-tab-pane label="基本信息" name="basic">
					<div class="contacts-section">
						<el-descriptions :column="2" border>
							<el-descriptions-item label="报价编号">{{ viewQuotation.name }}</el-descriptions-item>
							<el-descriptions-item label="客户名称">{{ viewQuotation.customerName }}</el-descriptions-item>
							<el-descriptions-item label="报价金额">{{ formatAmount(viewQuotation.offerPrice)
                            }}</el-descriptions-item>
							<el-descriptions-item
								label="成本金额">{{ formatAmount(viewQuotation.cost) }}</el-descriptions-item>
							<el-descriptions-item label="利润金额">{{ formatAmount(viewQuotation.profit)
                            }}</el-descriptions-item>
							<el-descriptions-item label="有效期至">{{ formatDate(viewQuotation.offerTime)
                            }}</el-descriptions-item>
							<el-descriptions-item label="报价状态">
								<el-tag :type="getStatusType(viewQuotation.status)">
									{{ getStatusText(viewQuotation.status) }}
								</el-tag>
							</el-descriptions-item>
							<el-descriptions-item label="创建时间">{{ formatDateTime(viewQuotation.createTime)
                            }}</el-descriptions-item>
							<el-descriptions-item label="备注说明" :span="2">
								<span style="white-space: pre-wrap">{{ viewQuotation.remark || '无' }}</span>
							</el-descriptions-item>
						</el-descriptions>
					</div>
				</el-tab-pane>

				<el-tab-pane label="报价明细" name="details">
					<div class="contacts-section">
						<el-table :data="viewQuotation.businessProducts" border style="width: 100%" height="42vh"
							stripe>
							<el-table-column type="index" label="序号" width="60" />
							<el-table-column prop="productName" label="产品名称"></el-table-column>
							<el-table-column prop="unit" label="单位" width="80"></el-table-column>
							<el-table-column prop="productNum" label="数量" width="100"></el-table-column>
							<el-table-column prop="productPrice" label="单价" width="130">
								<template #default="scope">
									{{ formatAmount(scope.row.productPrice) }}
								</template>
							</el-table-column>
							<el-table-column prop="amount" label="金额" width="140">
								<template #default="scope">
									{{ formatAmount(scope.row.amount) }}
								</template>
							</el-table-column>
						</el-table>
					</div>
				</el-tab-pane>

				<el-tab-pane label="审批列表" name="approval">
					<div class="contacts-section">
						<div v-if="viewQuotation.examineFlow">
							<el-table :data="viewQuotation.examineFlow" border style="width: 100%" height="42vh" stripe>
								<el-table-column type="index" label="序号" width="60" />
								<el-table-column prop="examineName" label="审批标题" min-width="160" />
								<el-table-column prop="username" label="申请人" width="90" />
								<el-table-column prop="createTime" label="申请时间" width="180">
									<template #default="scope">
										{{ formatDateTime(scope.row.createTime) }}
									</template>
								</el-table-column>
								<el-table-column prop="status" label="审批状态" width="90">
									<template #default="scope">
										<el-tag :type="getApprovalStatusType(scope.row.status)" size="small">
											{{ getApprovalStatusText(scope.row.status) }}
										</el-tag>
									</template>
								</el-table-column>
								<el-table-column prop="currentApprover" label="当前审批人" width="100" />
								<el-table-column label="操作" width="100" fixed="right">
									<template #default="scope">
										<el-button size="small" type="warning"
											@click="handleViewApproval(scope.row)">查看</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<el-empty v-else description="暂无审批信息"></el-empty>
					</div>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>

		<!-- 审批详情对话框 -->
		<el-dialog class="mydialog" title="审批详情" v-model="viewApprovalDialogVisible" width="800px"
			:close-on-click-modal="false">
			<el-tabs v-model="activeApprovalTab" type="border-card">
				<el-tab-pane label="基本信息" name="basic">
					<div class="contacts-section">
						<el-descriptions :column="2" border>
							<el-descriptions-item
								label="审批类型">{{ getTypeText(viewApproval.oaType) }}</el-descriptions-item>
							<el-descriptions-item label="审批标题">{{ viewApproval.examineName }}</el-descriptions-item>
							<el-descriptions-item label="申请人">{{ viewApproval.username }}</el-descriptions-item>
							<el-descriptions-item
								label="申请时间">{{ formatDateTime(viewApproval.createTime) }}</el-descriptions-item>
							<el-descriptions-item label="审批状态">
								<el-tag :type="getApprovalStatusType(viewApproval.status)">
									{{ getApprovalStatusText(viewApproval.status) }}
								</el-tag>
							</el-descriptions-item>
							<el-descriptions-item
								label="当前审批人">{{ viewApproval.currentApprover }}</el-descriptions-item>
						</el-descriptions>
					</div>
				</el-tab-pane>

				<el-tab-pane label="审批流程" name="process">
					<div class="contacts-section">
						<el-timeline>
							<el-timeline-item v-for="(activity, index) in viewApproval.process" :key="index"
								:type="getTimelineItemType(activity.status)" :timestamp="formatDateTime(activity.time)">
								<div class="timeline-item-content">
									<h4>第{{ index + 1 }}步</h4>
									<p><strong>审批人：</strong>{{ activity.username }}</p>
									<p><strong>审批状态：</strong>
										<el-tag :type="getApprovalStatusType1(activity.status)" size="small">
											{{ getApprovalStatusText1(activity.status) }}
										</el-tag>
									</p>
									<p v-if="activity.examineOpinion">
										<strong>审批意见：</strong>{{ activity.examineOpinion }}
									</p>
									<p><strong>审批时间：</strong>{{ formatDateTime(activity.updateTime) }}</p>
								</div>
							</el-timeline-item>
						</el-timeline>
					</div>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>

		<!-- 添加/编辑报价对话框 -->
		<el-dialog class="mydialog" :title="dialogTitle" v-model="dialogVisible" width="50vw"
			:close-on-click-modal="false" align-center>
			<el-form :model="quotationForm" :rules="rules" ref="quotationForm" label-width="auto">
				<el-row>
					<el-col :span="20">
						<el-form-item label="报价名称" prop="name">
							<el-input v-model="quotationForm.name" placeholder="请输入报价名"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="客户" prop="customerId">
							<el-select v-model="quotationForm.customerId" filterable placeholder="请选择客户"
								@change="handleCustomerChange1">
								<el-option v-for="customer in customerList" :key="customer.id"
									:label="customer.customerName" :value="customer.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="所属商机" prop="businessId">
							<el-select v-model="quotationForm.businessId" placeholder="请选择商机" filterable
								:disabled="!quotationForm.customerId" :loading="opportunityLoading"
								@change="handleOpportunityChange">
								<el-option v-for="item in opportunityOptions" :key="item.id" :label="item.name"
									:value="item.id">
									<span>{{ item.name }}</span>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="20">
						<el-form-item label="报价到期时间" prop="offerTime">
							<el-date-picker v-model="quotationForm.offerTime" type="date" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="报价" prop="offerPrice">
							<el-input-number v-model="quotationForm.offerPrice" :min="0"
								:precision="2"></el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="成本" prop="cost">
							<el-input-number v-model="quotationForm.cost" :min="0" :precision="2"></el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="利润" prop="profit">
							<el-input-number v-model="quotationForm.profit" :min="0" :precision="2"></el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="20">
						<el-form-item label="备注说明" prop="remark">
							<el-input type="textarea" v-model="quotationForm.remark" :rows="3"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- <el-form-item label="审批名称" prop="examineName">
                    <el-input v-model="quotationForm.examineName"></el-input>
                </el-form-item>
                <el-form-item label="审批模板" prop="temId">
                    <el-select v-model="quotationForm.temId" placeholder="请选择审批模板" filterable>
                        <el-option v-for="template in approvalTemplateList" :key="template.id" :label="template.name"
                            :value="template.id">
                            <div>
                                <div>{{ template.name }}</div>
                                <div style="font-size: 12px; color: #999;">
                                    {{ template.description }}
                                </div>
                            </div>
                        </el-option>
                    </el-select>
                </el-form-item> -->
				<!-- <el-form-item label="报价" prop="offerPrice">
					<el-input-number v-model="quotationForm.offerPrice" :min="0" :precision="2"></el-input-number>
				</el-form-item>
				<el-form-item label="成本" prop="cost">
					<el-input-number v-model="quotationForm.cost" :min="0" :precision="2"></el-input-number>
				</el-form-item>
				<el-form-item label="利润" prop="profit">
					<el-input-number v-model="quotationForm.profit" :min="0" :precision="2"></el-input-number>
				</el-form-item> -->
				<!-- <el-form-item label="报价时间" prop="offerTime">
                    <el-input v-model="quotationForm.offerTime" :rows="2"></el-input>
                </el-form-item> -->
				<!-- 报价明细 -->
				<div class="contacts-section">
					<div class="contacts-header">
						<h3>产品明细</h3>
						<el-button type="primary" @click="showProductSelector">
							<el-icon>
								<Plus />
							</el-icon> 添加产品
						</el-button>
					</div>
					<el-table :data="quotationForm.products" border stripe height="calc(100% - 75px)"
						style="width: 100%">
						<el-table-column type="index" label="序号" width="60" />
						<el-table-column prop="name" label="产品名称" width="200"></el-table-column>
						<el-table-column prop="specification" label="规格型号" width="120"></el-table-column>
						<el-table-column label="数量" width="180">
							<template #default="scope">
								<el-input-number v-model="scope.row.quantity" :min="1"
									@change="calculateItemAmount(scope.$index)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="unit" label="单位"></el-table-column>
						<el-table-column label="单价" width="180">
							<template #default="scope">
								<el-input-number v-model="scope.row.unitPrice" :min="0" :precision="2"
									@change="calculateItemAmount(scope.$index)"></el-input-number>
							</template>
						</el-table-column>
						<!-- <el-table-column label="成本价" width="180">
							<template #default="scope">
								<el-input-number v-model="scope.row.costPrice" :min="0" :precision="2"
									@change="calculateItemAmount(scope.$index)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="amount" label="金额">
							<template #default="scope">
								{{ formatAmount(scope.row.amount) }}
							</template>
						</el-table-column> -->
						<el-table-column label="操作" width="80" fixed="right">
							<template #default="scope">
								<el-button type="danger" size="small" @click="removeQuotationItem(scope.$index)">
									<el-icon>
										<Delete />
									</el-icon>
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!-- <el-form-item label="交货期" prop="deliveryTime">
                    <el-input v-model="quotationForm.deliveryTime"></el-input>
                </el-form-item> -->
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="submitQuotationForm">确 定</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 商机选择对话框 -->
		<el-dialog class="mydialog" v-model="opportunityDialogVisible" title="选择商机" width="1000px" :destroy-on-close="true"
			:close-on-click-modal="false" append-to-body>
			<div class="opportunity-search">
				<el-form :inline="true" :model="opportunitySearchForm">
					<el-form-item label="商机名称">
						<el-input v-model="opportunitySearchForm.name" placeholder="请输入商机名称" clearable />
					</el-form-item>
					<el-form-item label="客户名称">
						<!-- <el-input v-model="opportunitySearchForm.customerName" placeholder="请输入客户名称" clearable /> -->
						<el-select v-model="opportunitySearchForm.customerId" filterable placeholder="请选择客户"
							@change="handleCustomerChange1">
							<el-option v-for="customer in customerList" :key="customer.id"
								:label="customer.customerName" :value="customer.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="handleOpportunitySearch">
							<el-icon>
								<Search />
							</el-icon>搜索
						</el-button>
						<el-button @click="resetOpportunitySearch">
							<el-icon>
								<Refresh />
							</el-icon>重置
						</el-button>
					</el-form-item>
				</el-form>
			</div>

			<el-table v-loading="opportunityLoading" :data="opportunityList" border style="width: 100%"
				@row-click="handleOpportunitySelect" highlight-current-row>
				<el-table-column type="index" label="序号" width="60" />
				<el-table-column prop="name" label="商机名称" />
				<el-table-column prop="customerName" label="客户名称" />
				<el-table-column prop="amount" label="商机金额">
					<template #default="{ row }">
						{{ formatAmount(row.amount) }}
					</template>
				</el-table-column>
				<el-table-column prop="stage" label="商机阶段">
					<template #default="{ row }">
						<el-tag :type="getOpportunityStageType(row.stage)">
							{{ getOpportunityStageText(row.stage) }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="180">
					<template #default="{ row }">
						{{ formatDateTime(row.createTime) }}
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination-container">
				<el-pagination v-model:current-page="opportunityCurrentPage" v-model:page-size="opportunityPageSize"
					:page-sizes="[10, 20, 50, 100]" :total="opportunityTotal"
					layout="total, sizes, prev, pager, next, jumper" @size-change="handleOpportunitySizeChange"
					@current-change="handleOpportunityCurrentChange" />
			</div>

			<template #footer>
				<span class="dialog-footer">
					<el-button @click="handleClose">取消</el-button>
					<el-button type="primary" @click="confirmOpportunitySelect">
						确定
					</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 产品选择器对话框 -->
		<product-selector v-model="productSelectorVisible" @select="handleProductSelect"
			:close-on-click-modal="false" />

		<!-- 提交审核对话框 -->
		<el-dialog class="mydialog" title="提交审核" v-model="submitDialogVisible" width="30vw" :close-on-click-modal="false">
			<el-card shadow="never">
				<el-form :model="submitForm" :rules="submitRules" ref="submitFormRef" label-width="100px">
					<el-form-item label="审批名称" prop="examineName">
						<el-input v-model="submitForm.examineName" placeholder="请输入审批名称"></el-input>
					</el-form-item>
					<el-form-item label="审批模板" prop="temId">
						<el-select v-model="submitForm.temId" placeholder="请选择审批模板" filterable style="width: 100%">
							<el-option v-for="template in approvalTemplateList" :key="template.id"
								:label="template.name" :value="template.id">
								<div>
									<div>{{ template.name }}</div>
									<div style="font-size: 12px; color: #999;">
										{{ template.description }}
									</div>
								</div>
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</el-card>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="submitDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="confirmSubmit">确 定</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getQuotationList,
		addQuotation,
		updateQuotation,
		deleteQuotation,
		submitQuotation,
		sendQuotation,
		withdrawQuotation,
		getExamineList
	} from '@/api/quotation'
	import {
		getCustomerList
	} from '@/api/customer'
	import {
		getExamineFlowDetail
	} from '@/api/approval'
	import {
		getProductList
	} from '@/api/product'
	import {
		getOpportunityList
	} from '@/api/opportunity'
	import {
		getExamineTem
	} from '@/api/approval'
	import dayjs from 'dayjs'
	import {
		getCustomerOpportunities,
		searchCustomers
	} from '@/api/payment'
	import {
		ElMessage
	} from 'element-plus'
	import {
		Search,
		Refresh
	} from '@element-plus/icons-vue'
	import ProductSelector from '@/components/ProductSelector.vue'

	export default {
		name: 'QuotationManagement',
		components: {
			Search,
			Refresh,
			ProductSelector
		},
		data() {
			return {
				loading: false,
				filterForm: {
					quotationNo: '',
					customerName: '',
					status: '',
					startDate: '',
					endDate: '',
					type: 'all'
				},
				customerOptions: [],
				customerSearchLoading: false,
				dateRange: [],
				quotationList: [],
				customerList: [],
				productList: [],
				approvalTemplateList: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				dialogVisible: false,
				viewDialogVisible: false,
				dialogTitle: '新建报价',
				viewQuotation: {},
				quotationForm: {
					name: '',
					examineName: '',
					customerId: '',
					validUntil: '',
					products: [],
					paymentTerms: '',
					offerTime: '',
					remark: '',
					businessId: '',
					opportunityName: '',
					offerPrice: 0,
					cost: 0,
					profit: 0,
					examineTemId: ''
				},
				rules: {
					customerId: [{
						required: true,
						message: '请选择客户',
						trigger: 'change'
					}],
					profit: [{
						required: true,
						message: '请输入利润',
						trigger: 'change'
					}],
					name: [{
						required: true,
						message: '请选择报价名',
						trigger: 'change'
					}],
					examineName: [{
						required: true,
						message: '请输入审批名',
						trigger: 'change'
					}],
					cost: [{
						required: true,
						message: '请输入成本',
						trigger: 'blur'
					}],
					offerPrice: [{
						required: true,
						message: '请输入报价',
						trigger: 'blur'
					}],
					businessId: [{
						required: true,
						message: '请输入商机',
						trigger: 'blur'
					}],
					offerTime: [{
						required: true,
						message: '请输入报价时间',
						trigger: 'blur'
					}],
					examineTemId: [{
						required: true,
						message: '请选择审批模板',
						trigger: 'change'
					}],
					products: [{
							type: 'array',
							required: true,
							message: '请添加报价明细',
							trigger: 'change'
						},
						{
							type: 'array',
							min: 1,
							message: '至少添加一条报价明细',
							trigger: 'change'
						}
					]
				},
				opportunityDialogVisible: false,
				opportunityLoading: false,
				opportunityList: [],
				opportunityCurrentPage: 1,
				opportunityPageSize: 10,
				opportunityTotal: 0,
				opportunitySearchForm: {
					name: '',
					customerName: '',
					customerId: ''
				},
				selectedOpportunity: null,
				activeTab: 'basic',
				productSelectorVisible: false,
				submitDialogVisible: false,
				submitForm: {
					examineName: '',
					temId: '',
					quotationId: ''
				},
				submitRules: {
					examineName: [{
						required: true,
						message: '请输入审批名称',
						trigger: 'blur'
					}],
					temId: [{
						required: true,
						message: '请选择审批模板',
						trigger: 'change'
					}]
				},
				viewApprovalDialogVisible: false,
				viewApproval: {},
				activeApprovalTab: 'basic',
				opportunityOptions: []
			}
		},
		watch: {
			dateRange(val) {
				if (val) {
					this.filterForm.startDate = val[0]
					this.filterForm.endDate = val[1]
				} else {
					this.filterForm.startDate = ''
					this.filterForm.endDate = ''
				}
			}
		},
		created() {
			// 获取路由参数
			const {
				name
			} = this.$route.query
			if (name) {
				// 设置搜索条件
				this.filterForm.name = name
				// 执行搜索
				this.handleSearch()
			} else {
				// 如果没有参数，获取默认列表
				this.fetchData()
			}
			this.fetchCustomers()
			this.fetchProducts()
			this.fetchApprovalTemplates()
		},
		mounted() {
			// 添加处理 ResizeObserver 警告的代码
			// const resizeObserverError = window.addEventListener('error', (e) => {
			//     if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
			//         e.stopImmediatePropagation()
			//     }
			// })
		},
		beforeUnmount() {
			// 移除事件监听
			// window.removeEventListener('error', resizeObserverError)
		},

		methods: {
			async handleCustomerSearch(query) {
				if (query) {
					this.customerSearchLoading = true
					try {
						const res = await searchCustomers({
							name: query
						})
						this.customerOptions = res.data
					} catch (error) {
						console.error('搜索客户失败:', error)
						ElMessage.error('搜索客户失败')
					} finally {
						this.customerSearchLoading = false
					}
				} else {
					this.customerOptions = []
				}
			},
			handleCustomerChange(value) {
				console.log(value);
				this.opportunitySearchForm.customerId = value;
			},
			async handleCustomerChange1(customerId) {
				if (customerId) {
					this.opportunityLoading = true
					try {
						const res = await getCustomerOpportunities({
							cuId: customerId
						})
						this.opportunityOptions = res.data
						// 清空商机选择
						this.quotationForm.businessId = ''
					} catch (error) {
						console.error('获取客户商机失败:', error)
						ElMessage.error('获取客户商机失败')
					} finally {
						this.opportunityLoading = false
					}
				} else {
					this.opportunityOptions = []
					this.quotationForm.businessId = ''
				}
			},
			formatDateTime(date) {
				if (!date) return ''
				return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
			},
			formatDate(date) {
				if (!date) return ''
				return dayjs(date).format('YYYY-MM-DD')
			},
			formatAmount(amount) {
				if (!amount && amount !== 0) return '¥0.00'
				return `¥${Number(amount).toFixed(2)}`
			},
			getStatusType(status) {
				const statusMap = {
					0: 'primary',
					9: 'warning',
					1: 'success',
					4: 'info',
					2: 'danger'
				}
				return statusMap[status] || 'info'
			},
			getStatusText(status) {
				const statusMap = {
					0: '审核中',
					9: '未审核',
					1: '已审核',
					4: '已撤销',
					2: '已拒绝'
				}
				return statusMap[status] || status
			},
			async getExamineFlowList(row) {
				try {
					const params = {
						offerId: row.id,
					}
					const res = await getExamineList(params)
					this.viewQuotation.examineFlow = res.data
					// this.total = res.data.total
				} catch (error) {
					console.error('获取审批流程失败:', error)
				}
			},
			async fetchData() {
				try {
					const params = {
						current: this.currentPage,
						size: this.pageSize,
						...this.filterForm
					}
					const res = await getQuotationList(params)
					this.quotationList = res.data.records
					// this.quotationList.forEach(item => {
					//     item.businessProducts.forEach(product => {
					//         product.productName = product.product.name
					//         product.specification = product.product.specification
					//         product.unit = product.product.unit
					//         product.unitPrice = product.product.unitPrice
					//         product.amount = product.product.unitPrice * product.quantity
					//     })
					// })
					this.total = res.data.total
				} catch (error) {
					console.error('获取报价列表失败:', error)
				}
			},
			async fetchCustomers() {
				try {
					const res = await getCustomerList({
						current: 1,
						size: 1000
					})
					this.customerList = res.data.records
				} catch (error) {
					console.error('获取客户列表失败:', error)
				}
			},
			async fetchProducts() {
				try {
					const res = await getProductList({
						current: 1,
						size: 1000,
						name: ''
					})
					this.productList = res.data.records
				} catch (error) {
					console.error('获取产品列表失败:', error)
				}
			},
			async fetchApprovalTemplates() {
				try {
					const res = await getExamineTem({
						current: 1,
						size: 1000
					})
					this.approvalTemplateList = res.data.records
				} catch (error) {
					console.error('获取审批模板列表失败:', error)
					ElMessage.error('获取审批模板列表失败')
				}
			},
			handleSearch() {
				this.currentPage = 1
				this.fetchData();

			},
			resetForm() {
				this.filterForm = {
					quotationNo: '',
					customerName: '',
					status: '',
					startDate: '',
					endDate: ''
				}
				this.dateRange = []
				this.handleSearch()
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.fetchData()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.fetchData()
			},
			handleAddQuotation() {
				this.dialogTitle = '新建报价'
				this.quotationForm = {
					customerId: '',
					validUntil: '',
					products: [],
					paymentTerms: '',
					remark: '',
					businessId: '',
					opportunityName: '',
					offerPrice: 0,
					cost: 0,
					profit: 0,
					offerTime: '',
					examineTemId: ''
				}
				this.dialogVisible = true
			},
			handleEdit(row) {
				this.dialogTitle = '编辑报价'
				this.quotationForm = {
					id: row.id,
					name: row.name,
					customerId: row.customerId,
					cost: row.cost,
					offerPrice: row.offerPrice,
					profit: row.profit,
					offerTime: row.offerTime,
					// validUntil: row.validUntil,
					products: row.businessProducts,
					paymentTerms: row.paymentTerms,
					deliveryTime: row.deliveryTime,
					remark: row.remark,
					businessId: row.businessId,
					opportunityName: row.businessName,
					// examineTemId: row.examineTemId
				}
				row.businessProducts.forEach((product, index) => {
					this.quotationForm.products[index].name = product.productName
					this.quotationForm.products[index].specification = product.specification
					this.quotationForm.products[index].unit = product.unit
					this.quotationForm.products[index].unitPrice = product.productPrice
					// this.quotationForm.products[index].amount = product.unitPrice * product.quantity
					this.quotationForm.products[index].costPrice = product.costPrice
					this.quotationForm.products[index].productId = product.productId
					this.quotationForm.products[index].quantity = product.quantity
					this.quotationForm.products[index].remark = product.remark
					this.quotationForm.products[index].quantity = product.productNum
					this.quotationForm.products[index].amount = product.amount
				})
				// await updateQuotation(this.quotationForm)
				this.dialogVisible = true
			},
			handleView(row) {
				this.viewQuotation = {
					...row
				}
				this.viewDialogVisible = true
				this.getExamineFlowList(row)
			},
			async handleDelete(row) {
				try {
					await this.$confirm('确认删除该报价吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					await deleteQuotation(row.id)
					this.$message.success('删除成功')
					this.fetchData()
				} catch (error) {
					if (error !== 'cancel') {
						console.error('删除报价失败:', error)
					}
				}
			},
			async handleSubmit(row) {
				if (row.status === 0) {
					// 如果是审核中状态，执行撤回操作
					try {
						await this.$confirm('确认撤回该报价审批吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						})
						await withdrawQuotation({
							offerId: row.id
						})
						this.$message.success('撤回成功')
						this.fetchData()
					} catch (error) {
						if (error !== 'cancel') {
							console.error('撤回报价审批失败:', error)
							this.$message.error('撤回失败')
						}
					}
				} else {
					// 如果是未审核状态，执行提交审批操作
					this.submitForm = row
					this.submitForm = {
						id: row.id,
						name: row.name,
						customerId: row.customerId,
						cost: row.cost,
						offerPrice: row.offerPrice,
						profit: row.profit,
						offerTime: row.offerTime,
						products: row.businessProducts,
						paymentTerms: row.paymentTerms,
						deliveryTime: row.deliveryTime,
						remark: row.remark,
						businessId: row.businessId,
						opportunityName: row.businessName,
					}
					row.businessProducts.forEach((product, index) => {
						this.submitForm.products[index].name = product.productName
						this.submitForm.products[index].specification = product.specification
						this.submitForm.products[index].unit = product.unit
						this.submitForm.products[index].unitPrice = product.productPrice
						this.submitForm.products[index].amount = product.unitPrice * product.quantity
						this.submitForm.products[index].costPrice = product.costPrice
						this.submitForm.products[index].productId = product.productId
						this.submitForm.products[index].quantity = product.quantity
						this.submitForm.products[index].remark = product.remark
						this.submitForm.products[index].quantity = product.productNum
						this.submitForm.products[index].amount = product.amount
					})
					this.submitDialogVisible = true
				}
			},
			async confirmSubmit() {
				try {
					await this.$refs.submitFormRef.validate()
					this.submitForm.status = 0
					await submitQuotation(this.submitForm)
					this.$message.success('提交成功')
					this.submitDialogVisible = false
					this.fetchData()
				} catch (error) {
					if (error !== 'cancel') {
						console.error('提交报价失败:', error)
						this.$message.error('提交失败')
					}
				}
			},
			async handleSend(row) {
				try {
					await this.$confirm('确认发送该报价给客户吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					await sendQuotation(row.id)
					this.$message.success('发送成功')
					this.fetchData()
				} catch (error) {
					if (error !== 'cancel') {
						console.error('发送报价失败:', error)
					}
				}
			},
			addQuotationItem() {
				this.quotationForm.products.push({
					productId: '',
					productName: '',
					specification: '',
					unit: '',
					quantity: 1,
					unitPrice: 0,
					amount: 0,
					remark: ''
				})
				this.$nextTick(() => {
					this.$refs.quotationForm.validateField('products')
				})
			},
			removeQuotationItem(index) {
				this.quotationForm.products.splice(index, 1)
				this.calculateTotalAmount()
				this.$nextTick(() => {
					this.$refs.quotationForm.validateField('products')
				})
			},
			handleProductChange(productId, index) {
				const product = this.productList.find(p => p.id === productId)
				if (product) {
					const currentItem = this.quotationForm.products[index]
					this.quotationForm.products[index] = {
						...currentItem,
						costPrice: product.costPrice,
						productId: product.id,
						name: product.name,
						specification: product.specification,
						unit: product.unit,
						unitPrice: product.unitPrice,
						amount: currentItem.quantity * product.unitPrice
					}
					this.calculateTotalAmount()
				}
			},
			calculateItemAmount(index) {
				const item = this.quotationForm.products[index]
				item.amount = item.quantity * item.unitPrice
				this.calculateTotalAmount()
			},
			calculateTotalAmount() {
				this.quotationForm.totalAmount = this.quotationForm.products.reduce((sum, item) => {
					return sum + (item.amount || 0)
				}, 0)
			},
			async submitQuotationForm() {
				try {
					await this.$refs.quotationForm.validate()
					if (this.quotationForm.products.length === 0) {
						this.$message.warning('请添加报价明细')
						return
					}
					const formData = {
						...this.quotationForm,
						totalAmount: this.quotationForm.totalAmount || 0
					}
					if (this.quotationForm.id) {
						await updateQuotation(formData)
						this.$message.success('更新成功')
					} else {
						await addQuotation(formData)
						this.$message.success('添加成功')
					}
					this.dialogVisible = false
					this.fetchData()
				} catch (error) {
					console.error('提交表单失败:', error)
				}
			},
			showOpportunityDialog() {
				this.opportunityDialogVisible = true
				this.$nextTick(() => {
					this.fetchOpportunityList()
				})
			},
			async fetchOpportunityList() {
				this.opportunityLoading = true
				try {
					const res = await getOpportunityList({
						current: this.opportunityCurrentPage,
						size: this.opportunityPageSize,
						type: "all",
						customerId: this.opportunitySearchForm.customerId,
						...this.opportunitySearchForm
					})
					this.opportunityList = res.data.records
					this.opportunityTotal = res.data.total
				} catch (error) {
					console.error('获取商机列表失败:', error)
				} finally {
					this.opportunityLoading = false
				}
			},
			handleOpportunitySearch() {
				this.opportunityCurrentPage = 1
				this.fetchOpportunityList()
			},
			resetOpportunitySearch() {
				this.opportunitySearchForm = {
					name: '',
					customerName: ''
				}
				this.handleOpportunitySearch()
			},
			handleOpportunitySizeChange(val) {
				this.opportunityPageSize = val
				this.fetchOpportunityList()
			},
			handleOpportunityCurrentChange(val) {
				this.opportunityCurrentPage = val
				this.fetchOpportunityList()
			},
			handleOpportunitySelect(row) {
				this.selectedOpportunity = row
			},
			confirmOpportunitySelect() {
				if (!this.selectedOpportunity) {
					ElMessage.warning('请选择商机')
					return
				}

				this.quotationForm.businessId = this.selectedOpportunity.id
				this.quotationForm.opportunityName = this.selectedOpportunity.name
				this.opportunityDialogVisible = false
			},
			getOpportunityStageType(stage) {
				const types = {
					'1': 'info', // 初步接触
					'2': 'warning', // 需求确认
					'3': 'success', // 方案报价
					'4': 'danger' // 谈判签约
				}
				return types[stage] || 'info'
			},
			getOpportunityStageText(stage) {
				const texts = {
					'1': '初步接触',
					'2': '需求确认',
					'3': '方案报价',
					'4': '谈判签约'
				}
				return texts[stage] || '未知'
			},
			handleClose() {
				this.opportunityDialogVisible = false
				this.selectedOpportunity = null
				this.opportunityList = []
			},
			async handleApprove(row) {
				console.log(row)
				try {
					const res = await getExamineFlowDetail({
						id: row.id
					})
					console.log(res)
					this.viewApproval.process = res.data
					res.data.forEach(item => {
						if (item.userId === this.$store.state.user.id) {
							this.currentApproval = item
							this.approvalForm = {
								...item,
								ccUsers: []
							}
							this.approvalDialogVisible = true
						}
					})
				} catch (error) {
					console.error('获取审批流程失败:', error)
					this.$message.error('获取审批流程失败')
				}
			},
			getApprovalStatusType(status) {
				const statusMap = {
					1: 'warning', // 待审批
					3: 'success', // 已通过
					2: 'danger', // 已拒绝
					'-1': 'info', // 未撤回
					4: 'info' // 已撤销
				}
				return statusMap[status] || 'info'
			},
			getApprovalStatusText(status) {
				const statusMap = {
					1: '审批中',
					3: '已通过',
					2: '已拒绝',
					'-1': '未开始',
					4: '已撤销'
				}
				return statusMap[status] || '未知'
			},

			getApprovalStatusType1(status) {
				const statusMap = {
					0: 'warning', // 待审批
					1: 'success', // 已通过
					2: 'danger', // 已拒绝
					'-1': 'info', // 未撤回
					4: 'info' // 已撤销
				}
				return statusMap[status] || 'info'
			},
			getApprovalStatusText1(status) {
				const statusMap = {
					0: '审批中',
					1: '已通过',
					2: '已拒绝',
					'-1': '未开始',
					4: '已撤销'
				}
				return statusMap[status] || '未知'
			},
			showProductSelector() {
				this.productSelectorVisible = true
			},
			handleProductSelect(selectedProducts) {
				selectedProducts.forEach(product => {
					this.quotationForm.products.push({
						productId: product.id,
						name: product.name,
						specification: product.specification,
						unit: product.unit,
						quantity: 1,
						unitPrice: product.unitPrice,
						costPrice: product.costPrice,
						amount: product.unitPrice
					})
				})
				this.calculateTotalAmount()
				this.$nextTick(() => {
					this.$refs.quotationForm.validateField('products')
				})
			},
			handleViewApproval(row) {
				// 打开审批详情对话框
				this.viewApproval = row
				this.handleApprove(row)
				this.viewApprovalDialogVisible = true
			},
			getTypeText(type) {
				const typeMap = {
					1: '报价审批'
				}
				return typeMap[type] || type
			},
			getTimelineItemType(status) {
				const typeMap = {
					'-1': 'warning',
					0: 'primary',
					2: 'danger',
					1: 'success'
				}
				return typeMap[status] || 'info'
			},
			handleOpportunityChange() {
				// 可以在这里添加商机选择后的其他操作
			}
		}
	}
</script>

<style scoped>
	.pagination-container {
		margin-top: 20px;
		text-align: right;
	}

	.contacts-section {
		height: 300px;
	}

	.quotation-info {
		margin-top: 20px;
	}

	.quotation-info h3 {
		margin-bottom: 15px;
		font-size: 16px;
		color: #303133;
	}

	.opportunity-search {
		margin-bottom: 20px;
	}

	:deep(.el-form--inline .el-form-item) {
		margin-right: 0;
	}

	.timeline-item-content {
		padding: 5px 0;
	}

	.timeline-item-content h4 {
		margin: 0 0 10px 0;
		color: #409EFF;
	}

	.timeline-item-content p {
		margin: 5px 0;
		color: #606266;
	}

	.approval-process {
		margin-top: 20px;
	}

	.approval-process h3 {
		margin-bottom: 15px;
		font-size: 16px;
		color: #303133;
	}
</style>